export default function FilterBar({ filters, onChange }) {
  const handleFilterChange = (key, value) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-soft border border-[#E1DFD7] mb-8 sticky top-4 z-10" data-testid="filter-bar">
      <div className="grid md:grid-cols-3 gap-4">
        {/* Location Filter */}
        <div>
          <label className="block text-sm font-medium text-[#0B2240] mb-2">📍 Location</label>
          <select
            value={filters.location}
            onChange={(e) => handleFilterChange('location', e.target.value)}
            className="w-full h-11 px-4 rounded-[12px] border border-[#E1DFD7] bg-white focus:outline-none focus:ring-2 focus:ring-[#1FA3A3] focus:border-transparent"
            data-testid="filter-location"
          >
            <option value="all">All Locations</option>
            <option value="charlotte">Charlotte</option>
            <option value="mooresville">Mooresville</option>
            <option value="winston-salem">Winston-Salem</option>
          </select>
        </div>

        {/* Type Filter */}
        <div>
          <label className="block text-sm font-medium text-[#0B2240] mb-2">🏷️ Event Type</label>
          <select
            value={filters.type}
            onChange={(e) => handleFilterChange('type', e.target.value)}
            className="w-full h-11 px-4 rounded-[12px] border border-[#E1DFD7] bg-white focus:outline-none focus:ring-2 focus:ring-[#1FA3A3] focus:border-transparent"
            data-testid="filter-type"
          >
            <option value="all">All Types</option>
            <option value="networking_breakfast">Networking Breakfast</option>
            <option value="free_coffee_friday">Free Coffee Friday</option>
            <option value="charity">Community & Charity</option>
          </select>
        </div>

        {/* Month Filter */}
        <div>
          <label className="block text-sm font-medium text-[#0B2240] mb-2">📅 Time</label>
          <select
            value={filters.month}
            onChange={(e) => handleFilterChange('month', e.target.value)}
            className="w-full h-11 px-4 rounded-[12px] border border-[#E1DFD7] bg-white focus:outline-none focus:ring-2 focus:ring-[#1FA3A3] focus:border-transparent"
            data-testid="filter-month"
          >
            <option value="current">Current Month</option>
            <option value="next">Next Month</option>
            <option value="all">All Upcoming</option>
          </select>
        </div>
      </div>
    </div>
  );
}
